import { render } from "./ProjectFundsPdfView.vue?vue&type=template&id=36a280e9"
import script from "./ProjectFundsPdfView.vue?vue&type=script&lang=js"
export * from "./ProjectFundsPdfView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__